<section *ngIf="!violation" class=" text-center ">
  <img src="assets/images/no-data.svg" height="400px" width="400px" alt="..." class="img-thumbnail border-0">
  <h6 *ngIf="!violation">{{viewViolationDetailsLabel}}</h6>
</section>

<section *ngIf="violation">

  <div class="accordion rounded-pill pb-2" id="accordionPanelsStayOpenExample">
    <div class="accordion-item d-flex border-0">
      <i class="far fa-clipboard text-primary icon-h rounded-circle"></i>
      <h4 class="accordion-header text-primary font-2x pt-1 " id="panelsStayOpen-headingOne">
        {{violationLabel}}: <span class="fw-normal">{{ violation.ViolationName }} - {{ violation.AgentFirstName + " " +
          violation.AgentLastName}}
        </span>
      </h4>
    </div>
  </div>

  <div class="accordion rounded-pill mx-2 position-relative accordion-bg-cl " id="accordionPanelsStayOpenExample">
    <div class="custom-area overflow-auto" style="height: 45vh;">
      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="cameracollapsed? 'collapsed' : '' " (click)="toggleCameracollapsed()">
            <i class="fal fa-camera px-2"></i>
            {{cameraShotLabel}}
          </button>
        </h2>
        <div #scroll style="overflow: auto;" id="panelsStayOpen-collapseOne" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-headingOne" [ngClass]="cameracollapsed? 'hide' : 'show' ">
          <div class="accordion-body text-center ">
            <img class="w-50 h-50" src="{{secureCamPicURL}}" />
          </div>
        </div>
      </div>

      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-heading2">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="Videocollapsed? 'collapsed' : '' " (click)="toggleVideocollapsed()"
            aria-controls="panelsStayOpen-collapse2">
            <i class="fal fa-camera-movie px-2"></i>
            {{cameraVideoLabel}}
          </button>
        </h2>
        <div #scroll style="overflow: auto;" id="panelsStayOpen-collapse2" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-heading2" [ngClass]="Videocollapsed? 'hide' : 'show' ">
          <div class="accordion-body text-center ">
            <video class="w-50 h-50" src="{{secureCamVideoURL}}" controls="controls"></video>
          </div>
        </div>
      </div>

      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-heading3">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="SScollapsed? 'collapsed' : '' " (click)="toggleSScollapsed()"
            aria-controls="panelsStayOpen-collapse3">
            <i class="fal fa-image-polaroid px-2"></i>
            {{screenshotLabel}}
          </button>
        </h2>
        <div #scroll style="overflow: auto;" id="panelsStayOpen-collapse3" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-heading3" [ngClass]="SScollapsed? 'hide' : 'show' ">
          <div class="accordion-body text-center ">
            <img class="w-50 h-50" src="{{secureScreenshotURL}}" />
          </div>
        </div>
      </div>

      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-heading8">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="SRcollapsed? 'collapsed' : '' " aria-controls="panelsStayOpen-collapse8"
            (click)="toggleSRcollapsed()">
            <i class="fal fa-camera-movie px-2"></i>
            {{screenVideoLabel}}
          </button>
        </h2>
        <div #scroll style="overflow: auto;" id="panelsStayOpen-collapse8" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-heading8" [ngClass]="SRcollapsed? 'hide' : 'show' ">
          <div class="accordion-body text-center ">
            <video class="w-50 h-50" src="{{secureScreenVideoURL}}" controls="controls"></video>
          </div>
        </div>
      </div>

      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-heading10">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="Geocollapsed? 'collapsed' : '' " (click)="toggleGeocollapsed()">
            <i class="fal fa-map-marker-alt px-2"></i>
            {{geoLocationLabel}}
          </button>
        </h2>


        <div style="overflow: auto;" id="panelsStayOpen-collapse10" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-heading10" [ngClass]="Geocollapsed? 'hide': 'show'">
          <div class="accordion-body text-center border w-90 h-90">
            {{locationLabel}}:{{violation.Latitude}}, {{violation.Longitude}}
            <app-map [Latitude]=violation.Latitude [Longitude]=violation.Longitude></app-map>
          </div>
        </div>
      </div>

      <div class="m-1 accordion-item border-0">
        <h2 class="accordion-header" id="panelsStayOpen-heading7">
          <button class="accordion-button accordian-bar rounded-corner" type="button"
            [ngClass]="IPcollapsed? 'collapsed' : '' " (click)="toggleIPcollapsed()"
            aria-controls="panelsStayOpen-collapse7">
            <i class="fal fa-globe px-2"></i>
            {{ipLabel}}
          </button>
        </h2>
        <div #scroll style="overflow: auto;" id="panelsStayOpen-collapse7" class="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-heading7" [ngClass]="IPcollapsed? 'hide': 'show'">
          <div class="accordion-body text-center ">
            {{ violation.Ip }}
          </div>
        </div>
      </div>
    </div>

    <div class="card f b-color m-2 p-2 " style="border-radius: 15px ">
      <div class=" d-flex">
        <label for="floatingTextarea2" class="fw-bold font-sm px-2 py-0 text-primary">
          {{violation.SentBy + ":" }}</label>
        <p class="boxheight custom-area overflow-auto text-break w-100 form-control border-0 py-0  m-0 "
          id="floatingTextarea2"> {{violation.SenderComments}}</p>
      </div>
    </div>

    <div class="card f b-color m-2 p-2 comment-bgcolor " style="border-radius: 15px ">
      <div class=" d-flex ">
        <label class="fw-bold text-primary px-2 py-1 mt-1 ">
          {{commentsLabel}}: </label>
        <input style="border-radius: 15px " type="text" class=" form-control" placeholder="{{typeCommentLabel}}"
          [(ngModel)]="txtComment" maxlength="300">
      </div>
    </div>
  </div>
  <div class="float-end">
    <button type="button" class="btn button-primary mx-1 "
      (click)="sendApproveStatus('Approve')">{{approveLabel}}</button>
    <button type="button" class="btn button-danger mx-1" (click)="sendApproveStatus('Reject')">{{rejectLabel}}</button>
  </div>
</section>

<div class="modal" [ngStyle]="{'display':showConfirm}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm  rounded-corner border-0" role="document">
    <div class="modal-content rounded-corner ">
      <div class="modal-header border-0">
        <h5 class="modal-title text-primary font-2x"><i _ngcontent-mft-c58="" class="fal fa-file-alt icon-header"
            aria-hidden="true"></i>
          {{ approveStatus }} {{violationLabel}}</h5>
        <button type="button" class="btn close" data-dismiss="modal" aria-label="Close" (click)="closeConfirm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <p>{{ approveStatus === 'Approve' ? wantToApproveLabel : wantToRejectLabel }}?</p>
      </div>

      <div class="modal-footer border-0">
        <div class="justify-content-end">
          <button type="button" class="btn button-primary me-2" (click)="sendApproveStatusToServer()">{{approveStatus
            === 'Approve' ? approveLabel : rejectLabel}}</button>
          <button type="button" class="btn button-danger" data-dismiss="modal"
            (click)="closeConfirm()">{{closeButton}}</button>
        </div>
      </div>
    </div>
  </div>
</div>